var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"portfolio"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/presentation/d/e/2PACX-1vQVHWBjCmtS1dpgieRBU5kgqS4tEqo2BJLiJW58fwgV8pWo8iIZZD36uGHCLhRTfe59LQcVpz_5vrx8/pubembed?start=false&loop=false&delayms=60000","frameborder":"0","id":"slides_embed","allowfullscreen":"true","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})])
}]

export { render, staticRenderFns }